import React, { useEffect, useState, useCallback } from "react";
import { Link } from "react-router-dom";
// import Select from "react-select"; 
// FeatherIcon from "feather-icons-react";
import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar";
import axios from "../api/axios";
import FindModuleById from '.././FindModuleById';
import { useFormik, FormikProvider, FieldArray } from "formik";
import {  Apitoken, Authtoken } from "../Global";
import { ToastContainer, toast } from "react-toastify";
import  "./../assets/css/custom.css";
import "react-toastify/dist/ReactToastify.css";
import $ from "jquery";
// import { useDropzone } from "react-dropzone";
import Cropper from "react-easy-crop";
import Slider from "@mui/material/Slider";
import Button from "@mui/material/Button";
// import Alert from "@mui/material/Alert";
// import "@pqina/pintura/pintura.css";
import DropzoneComponent from "./DropzoneComponent"; // Import the custom Dropzone
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";

const AddProduct = () => {
  const [ordersLists, setOrdersLists] = useState([]);
  const [menu, setMenu] = useState(false);
  const [backendErrors, setBackendErrors] = useState([]);
  // const [backendSuccess, setBackendSuccess] = useState(null);
 // IMAGE HANDLING STATES
 const [images, setImages] = useState([]);
 const [currentImageIndex, setCurrentImageIndex] = useState(0);
 const [crop, setCrop] = useState({ x: 0, y: 0 });
 const [zoom, setZoom] = useState(1);
 const [rotation, setRotation] = useState(0);
 const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
//  const [loading, setLoading] = useState(false);
//  const [error, setError] = useState(null);
 const [showCropper, setShowCropper] = useState(false);
 const [permission, setPermission] = useState({});

  //const [files, setFiles] = useState<FilePondFile[]>([]);
  // const [files, setFiles] = useState([]);


  // const generateToken = () => {
  //   const array = new Uint8Array(16); // 16 bytes = 128-bit token
  //   crypto.getRandomValues(array);
  //   return Array.from(array, byte => byte.toString(16).padStart(2, '0')).join('');
  // };
  const formik = useFormik({
    initialValues: {
      
      name: "",
      description: "",
      product_type:'',
      file:'',
      pallets: [
        {
          pictures: [],
        },
      ],
    },
    onSubmit: (values, { setSubmitting }) => {
    // console.log("Form submitted with values: ", values); // Check if form submission triggers

     const pallets12 = values.pallets.slice(-1);
    // console.log(pallets12);

     values.pallets = pallets12;
     //console.log(values);


    // return false;
      axios
        .post("/products/add", values, {
          headers: { 
            Authorization: `Bearer ${Authtoken}`, 
            Apitoken: Apitoken,
          //  'Content-Type': 'multipart/form-data', // Important!

          },
        })
        .then((response) => {
          $("#form-submit").text("Add Production Output");
          if (response.data.code === 200) {
           
            setSubmitting(false);
            toast.success(response.data.message);
           // setBackendSuccess(response.data.message);
            setTimeout(() => {
              window.location.href = "/products";
            }, 1000);
          } else {
            setBackendErrors(response.data.error);
            setSubmitting(false);
          }
        })
        .catch((error) => {
          toast.error(error.message);
        });
    },
  });


  useEffect(() => {
        setPermission(FindModuleById(5)); 
    console.log(permission);

    axios
      .get("/helpers/products-type", {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      })
      .then((response) => {
        if (response.data.code === 200) {
          let supplier_types = response.data.data.product_types;
          let supplier_typesList = supplier_types.map((cat, index) => ({
            label: cat.title,
            value: cat.id,
            key: `product-${index}`,
          }));
          setOrdersLists(supplier_typesList);
        
        } else {
          console.log("API response is not an array");
        }
      })
      .catch((error) => {
        console.log(error);
      });


  
  }, []);

  // const toggleMobileMenu = () => {
  //   setMenu(!menu);
  // };
  const customHandleInput = (event) => {
    const Input_name = event.target.name;
    delete backendErrors[Input_name];
  };

 
  const fileToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file); // Converts file to Base64
      reader.onload = () => resolve(reader.result); // Base64 string
      reader.onerror = (error) => reject(error);
    });
  };

const onDrop = useCallback(
  async (acceptedFiles, palletIndex) => {
    const filesArray = Array.from(acceptedFiles);
    const currentPictures = formik.values.pallets[palletIndex]?.pictures || [];

    try {
      const resizedImages = await Promise.all(
        filesArray.map(async (file) => {
          const base64Image = await fileToBase64(file);
          return resizeImage(base64Image, 1000, 1000); // Resize to 65mm x 65mm (approx. 246px x 246px)
        })
      );

      let updatedPictures = [...currentPictures, ...resizedImages];
      if (updatedPictures.length > 6) {
        updatedPictures.length = 6;
      }

      // formik.setFieldValue(`pallets[${palletIndex}].pictures`, updatedPictures);

      // setImages((prevImages) => {
      //   const newImages = Array.isArray(prevImages) ? [...prevImages] : [];
      //   newImages[palletIndex] = updatedPictures;
      //   return newImages;
      // });

        // Update Formik's state for the specific pallet
        formik.setFieldValue(`pallets[${palletIndex}].pictures`, updatedPictures);

        // Use a function inside setImages to ensure the previous state is maintained
        setImages((prevImages) => {
          const newImages = Array.isArray(prevImages) ? [...prevImages] : [];
          newImages[palletIndex] = updatedPictures;
          return newImages;
        });
    } catch (error) {
      console.error("Error resizing images:", error);
    }
  },
  [formik]
);
  // const getDropzoneProps = (palletIndex) => {
  //   return useDropzone({
  //     accept: "image/*",
  //     multiple: true,
  //     onDrop: (acceptedFiles) => onDrop(acceptedFiles, palletIndex),
  //   });
  // };

const onCropComplete = useCallback((croppedArea, croppedAreaPixels) => {
  setCroppedAreaPixels(croppedAreaPixels);
}, []);

// const resizeImage12 = (base64Str, maxWidth, maxHeight) => {
//   return new Promise((resolve) => {
//     const img = new Image();
//     img.src = base64Str;
//     img.onload = () => {
//       const canvas = document.createElement("canvas");
//       const ctx = canvas.getContext("2d");
//       canvas.width = maxWidth;
//       canvas.height = maxHeight;
//       ctx.drawImage(img, 0, 0, maxWidth, maxHeight);
//       resolve(canvas.toDataURL("image/jpeg"));
//     };
//   });
// };
const resizeImage = (base64Str, maxWidth, maxHeight) => {
  return new Promise((resolve) => {
    const img = new Image();
    img.src = base64Str;
    img.onload = () => {
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");

      let { width, height } = img;

      // Calculate the new dimensions while maintaining aspect ratio
      if (width > maxWidth || height > maxHeight) {
        if (width > height) {
          height = (maxHeight / width) * height;
          width = maxWidth;
        } else {
          width = (maxWidth / height) * width;
          height = maxHeight;
        }
      }

      canvas.width = width;
      canvas.height = height;
      ctx.drawImage(img, 0, 0, width, height);

      resolve(canvas.toDataURL("image/jpeg"));
    };
  });
};


const getCroppedImage = async (imageSrc) => {
  const image = new Image();
  image.src = imageSrc;

  return new Promise((resolve, reject) => {
    image.onload = () => {
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");

      // Set canvas size to the cropped area resolution
      const scaleX = image.naturalWidth / image.width; // Adjust for potential scaling
      const scaleY = image.naturalHeight / image.height;

      const croppedWidth = croppedAreaPixels.width * scaleX;
      const croppedHeight = croppedAreaPixels.height * scaleY;

      canvas.width = croppedWidth;
      canvas.height = croppedHeight;

      // Apply rotation and cropping
      ctx.translate(canvas.width / 2, canvas.height / 2);
      ctx.rotate((rotation * Math.PI) / 180);
      ctx.translate(-canvas.width / 2, -canvas.height / 2);

      ctx.drawImage(
        image,
        croppedAreaPixels.x * scaleX,
        croppedAreaPixels.y * scaleY,
        croppedWidth,
        croppedHeight,
        0,
        0,
        canvas.width,
        canvas.height
      );

      // Export as a high-quality image
      const base64Image = canvas.toDataURL("image/jpeg", 1.0); // 95% quality
      resolve(base64Image);
    };

    image.onerror = (err) => reject(err);
  });
};


  
const handleSaveCroppedImage = async (palletIndex, imgIndex) => {
  //setLoading(true);
  try {
    const croppedImageUrl = await getCroppedImage(
      images[palletIndex][imgIndex]
    );
    const updatedImages = [...formik.values.pallets[palletIndex].pictures];
    updatedImages[imgIndex] = croppedImageUrl;
    formik.setFieldValue(`pallets[${palletIndex}].pictures`, updatedImages);

    // setImages((prev) => ({
    //   ...prev,
    //   [palletIndex]: updatedImages,
    // }));
    setImages((prevImages) => {
      const newImages = [...prevImages]; // Create a shallow copy of the outer array
      newImages[palletIndex] = [...newImages[palletIndex]]; // Create a shallow copy of the specific pallet's images
      newImages[palletIndex][imgIndex] = croppedImageUrl; // Update the specific image
      return newImages; // Return the updated array
    });
  } catch (error) {
    console.error("Error saving cropped image:", error);
  } finally {
    //setLoading(false);
  }

  setShowCropper(false);
};
  
      


 

      const handleDeleteImage = (palletIndex, imgIndex) => {
        // Get a deep copy of the current state of pallets' pictures
        const updatedPallets = [...formik.values.pallets];
      
        // Ensure that we're working on a copy of the specific pallet's pictures array
        const currentPictures = [...(updatedPallets[palletIndex]?.pictures || [])];
      
       
      
        // Remove the image from the local state
        if (currentPictures.length > imgIndex) {
          currentPictures.splice(imgIndex, 1); // Remove the image at imgIndex
        }
      
        // Update the specific pallet's pictures in the deep copy of the formik state
        updatedPallets[palletIndex].pictures = currentPictures;
      
        // Update formik's state with the modified copy
        formik.setFieldValue(`pallets`, updatedPallets);
      
        // Update the images state to reflect the change locally (for rendering)
        setImages((prevImages) => {
          const newImages = [...prevImages];
          newImages[palletIndex] = currentPictures;
          return newImages;
        });
      
        // Update currentImageIndex if necessary to prevent out-of-bounds issues
        if (imgIndex === currentImageIndex) {
          setCurrentImageIndex(Math.max(0, imgIndex - 1));
        }
      };


 

  

  // const handleImageClick = (imgIndex) => {
  //   setCurrentImageIndex(imgIndex);
  //   setShowCropper(true); // Show the cropper container when an image is clicked
  // };
  const [activePalletIndex, setActivePalletIndex] = useState(null);

  const handleImageClick = (palletIndex, imgIndex) => {
    setCurrentImageIndex(imgIndex);
    setActivePalletIndex(palletIndex); // Set the active pallet index to show the cropper for that pallet
    setShowCropper(true);
  };


  const handleMoveImage = (palletIndex, imgIndex, direction) => {
    // Create a copy of the current pallet's images
    const updatedImages = [...images[palletIndex]];
  
    // Swap the current image with the one in the direction
    const swapIndex = imgIndex + direction;
    [updatedImages[imgIndex], updatedImages[swapIndex]] = [
      updatedImages[swapIndex],
      updatedImages[imgIndex],
    ];
  
    // Update the images state
    setImages((prev) => {
      const newImages = [...prev];
      newImages[palletIndex] = updatedImages;
      return newImages;
    });
  
    // Update Formik state
    formik.setFieldValue(`pallets[${palletIndex}].pictures`, updatedImages);
  };
  

  // const handleSelectChange = (name, selectedOption) => {
  //   const value = selectedOption ? selectedOption.value : "";
  //   updateFormikValue(name, value);
  //   customHandleInput({ target: { name, value } });
  // };
  
  // const updateFormikValue = (name, value) => {
  //   formik.setFieldValue(name, value);
  // };
 console.log(ordersLists);

  return (
    <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
      <Header onMenuClick={() => setMenu(!menu)} />
      <Sidebar />  <ToastContainer />
      <div className="page-wrapper">
        <div className="content container-fluid">
          <div className="page-header">
            <div className="row">
              <div className="col-sm-12">
                <h3 className="page-title">Product</h3>
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/profile">Profile</Link>
                  </li>
                  <li className="breadcrumb-item">
                    <Link to="/products">Products</Link>
                  </li>
                  <li className="breadcrumb-item active">Add Product</li>
                </ul>
              </div>
            </div>
          </div>
          {permission && permission.add === 1 && (

          <FormikProvider value={formik}>
            <form action="#" onSubmit={formik.handleSubmit}>
              {/* Additional fields and pallets */}
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group">
                    <label>Name </label>
                    <input
                      type="text"
                      name="name"
                      value={formik.values.name}
                      className="form-input form-control input-error"
                      onChange={(e) => {
                        formik.handleChange(e);
                        customHandleInput(e);
                      }}
                      onBlur={formik.handleBlur}
                    />
                    <small>
                      {backendErrors.name && (
                        <span className="form-error mt-1">
                          {backendErrors.name}
                        </span>
                      )}
                    </small>
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="form-group status">
                    <label>Product Type</label>
                    {/* <Select
                     className="w-100"
                     value={ordersLists.find(option => option.value == formik.values.product_type) || null} // Ensure correct format
                     name="product_type"
                        onChange={(selectedOption) => {
                        handleSelectChange("product_type", selectedOption); 
                     
                      }}
                     onBlur={formik.handleBlur}
                     options={ordersLists}
                     placeholder="Select"

                    /> */}
                       <input
                      type="text"
                      name="product_type"
                      value={formik.values.product_type}
                      className="form-input form-control input-error"
                      onChange={(e) => {
                        formik.handleChange(e);
                        customHandleInput(e);
                      }}
                      onBlur={formik.handleBlur}
                    />

                    <small>
                      {backendErrors.product_type && (
                        <span order="form-error mt-1">
                          {backendErrors.product_type}
                        </span>
                      )}
                    </small>
                  </div>
                </div>

                
                <div className="col-md-12">
                  <div className="form-group">
                    <label>Description </label>
                    <textarea
                      type="text"
                      name="description"
                      value={formik.values.description}
                      className="form-input form-control input-error"
                      onChange={(e) => {
                        formik.handleChange(e);
                        customHandleInput(e);
                      }}
                      onBlur={formik.handleBlur}
                    ></textarea>
                    <small>
                      {backendErrors.description && (
                        <span className="form-error mt-1">
                          {backendErrors.description}
                        </span>
                      )}
                    </small>
                  </div>
                </div>
             <div className="col-md-6">
                <div className="form-group status">
                    <label>Attach Product&apos;s specs</label>
                  
                        <input
                          className="form-control"
                          type="file"
                          name="file"
                          onChange={(event) => {
                            const file_link = event.target.files[0];
                            //console.log("file:", file_link);
                            //const fileName = file_link.name;
                            // const fileName = file_link.name;
                            const reader = new FileReader();

                            reader.onloadend = () => {
                              formik.setFieldValue(
                                "file",
                                reader.result
                              );
                            };

                            if (file_link) {
                              reader.readAsDataURL(file_link);
                            }
                          }}
                        />
                      
                  <small>
                      {backendErrors.file && (
                          <span className="form-error mt-1">
                            {backendErrors.file}
                          </span>
                        )}
                    </small>
                  </div>
                </div>
               
              </div>

              <div className="row">
                <div className="col-md-6">
                  <h3 className="card-title">
                    <br />
                    Images
                  </h3>
                </div>
              </div>

              <FieldArray
                name="pallets"
                render={() => (
                  <div>
                   
                    {formik.values.pallets.map((item, palletIndex) => (
                      <div key={palletIndex}>
                        <div className="row">

                          <div className="col-md-11">
                          <DropzoneComponent
                          palletIndex={palletIndex}
                          onDrop={onDrop} // Pass onDrop as a prop
                        />
                  <div
                    style={{
                      display: "flex",
                      marginTop: "20px",
                      flexWrap: "wrap",
                    }}
                  >
                    {images[palletIndex]?.map((image, imgIndex) => (
                      <div
                        key={imgIndex}
                        style={{
                          position: "relative",
                          margin: "10px",
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                        }}
                      >
                        <img
                          src={image}
                          alt={`preview ${imgIndex}`}
                          style={{
                            width: "150px",
                            cursor: "pointer",
                            border: currentImageIndex === imgIndex ? "2px solid blue" : "none",
                          }}
                          onClick={() => handleImageClick(palletIndex, imgIndex)}
                        />
                        <div style={{ marginTop: "5px" }}>
                          <Button
                            variant="contained"
                            color="primary"
                            disabled={imgIndex === 0} // Disable "Move Up" for the first image
                            onClick={() => handleMoveImage(palletIndex, imgIndex, -1)}
                            style={{ marginRight: "5px" }}
                          >
                            Up
                          </Button>
                          <Button
                            variant="contained"
                            color="primary"
                            disabled={imgIndex === images[palletIndex].length - 1} // Disable "Move Down" for the last image
                            onClick={() => handleMoveImage(palletIndex, imgIndex, 1)}
                          >
                            Down
                          </Button>
                        </div>
                        <Button
                          variant="contained"
                          color="secondary"
                          onClick={() => handleDeleteImage(palletIndex, imgIndex)}
                          style={{
                            marginTop: "5px",
                            backgroundColor: "red",
                            color: "white",
                            fontSize: "10px",
                          }}
                        >
                          x
                        </Button>
                      </div>
                    ))}
                  </div>

                            
                  {images[palletIndex]?.length > 0 && (
                    <Dialog
                      open={showCropper && activePalletIndex === palletIndex}
                      onClose={() => setShowCropper(false)} // Close the popup
                      fullWidth
                      maxWidth="sm"
                    >
                      <DialogTitle>Image Editor</DialogTitle>
                      <DialogContent>
                        <div
                          style={{
                            position: "relative",
                            height: "400px",
                            width: "100%",
                          }}
                        >
                          <Cropper
                            image={images[palletIndex][currentImageIndex]}
                            crop={crop}
                            zoom={zoom}
                            aspect={1}
                            rotation={rotation}
                            onCropChange={setCrop}
                            onZoomChange={setZoom}
                            onCropComplete={onCropComplete}
                          />
                        </div>

                        <div>
                          <h4>Rotation</h4>
                          <Slider
                            value={rotation}
                            onChange={(e, newValue) => setRotation(newValue)}
                            min={0}
                            max={360}
                          />
                        </div>

                        <div>
                          <h4>Zoom</h4>
                          <Slider
                            value={zoom}
                            min={1}
                            max={3}
                            step={0.1}
                            onChange={(e, newZoom) => setZoom(newZoom)}
                          />
                        </div>
                      </DialogContent>

                      <DialogActions>
                        <Button
                          variant="contained"
                          color="primary"
                          onClick={() => {
                            handleSaveCroppedImage(palletIndex, currentImageIndex);
                            setShowCropper(false); // Close the popup after saving
                          }}
                        >
                          Save Cropped Image
                        </Button>
                        <Button
                          variant="outlined"
                          color="secondary"
                          onClick={() => setShowCropper(false)} // Close the popup without saving
                        >
                          Cancel
                        </Button>
                      </DialogActions>
                    </Dialog>
                  )}


                          </div>
                         
                        
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              />
              <div className="text-end mt-4">
                <button
                  type="submit"
                  className="btn btn-primary"
                  disabled={formik.isSubmitting}
                >
                  Add Product
                </button>
              </div>
            </form>
          </FormikProvider>
       
              )}
       </div>
      </div>
    </div>
  );
};

export default AddProduct;